import { createContext, useContext, ReactNode } from 'react';
import { useAuth } from 'react-oidc-context';
import { Organization } from '../types';

interface OrganizationContextValue {
  organization: Organization | null;
  isLoading: boolean;
}

const OrganizationContext = createContext<OrganizationContextValue | undefined>(undefined);

export function OrganizationProvider({ children }: { children: ReactNode }) {
  const auth = useAuth();
  
  const organization: Organization | null = auth.user ? {
    organization_id: auth.user.profile?.website || '',
    organization_name: auth.user.profile?.profile || ''
  } : null;

  return (
    <OrganizationContext.Provider value={{ organization, isLoading: auth.isLoading }}>
      {children}
    </OrganizationContext.Provider>
  );
}

export function useOrganization() {
  const context = useContext(OrganizationContext);
  if (context === undefined) {
    throw new Error('useOrganization must be used within an OrganizationProvider');
  }
  return context;
}

